import styled from "styled-components";

export const StyledIcon = styled.div`
    & .Polaris-Icon {
        margin: unset;
    }
`;

export const StyledButtonGroup = styled.div`
    & .Polaris-ButtonGroup {
        align-items: start;
    }
`;

export const StyledResourceList = styled.div`
    .Polaris-ResourceList {
        border: 1px solid var(--p-color-border);
        border-radius: 10px;
        overflow: hidden;
    }
`

export const StyledBadge = styled.div`
    .Polaris-Badge {
        flex-direction: row-reverse;
        gap: 8px;
        padding: 2px 4px;
        align-items: center;
        background: #e3e3e3;
        cursor: pointer;

        &:hover {
            background: #c7c7c7;
        }
    }
`

export const StyledTab = styled.div`    
    .Polaris-Button--pressed, .Polaris-Button--pressed:hover, .Polaris-Button--pressed:active, .Polaris-Button--pressed:focus-visible {
        background: var(--p-color-bg-fill-transparent-selected);
    }
`